let hasAiAccess = true;

export function userHasSubscription() {
    const el = document.querySelector(
        '.transcribe-toolbar[data-has-subscription]'
    );
    const raw = el?.getAttribute("data-has-subscription");
    if (raw == null) return true;

    return raw === "1" || raw === "true";
}

export function isSubscriptionGateEnabled() {
    return !userHasSubscription();
}

export function isAiAccessAllowed() {
    return hasAiAccess;
}

export function disableAiAccess() {
    hasAiAccess = false;
}

